'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');
const components_navigation_Link_Link = require('../../navigation/Link/Link.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_rowby_1";
const text = "_text_rowby_32";
const styles = {
	root: root,
	text: text
};

const MenuItem = (props) => {
  const ariaLabel = props.isSelected ? `${props["aria-label"] || props.children}, selected` : props["aria-label"];
  const liRole = props.role ? { role: "none" } : null;
  const commonProps = {
    "aria-label": ariaLabel,
    className: clsx__default.default(styles.root, props.className),
    "data-selected": props.isSelected || void 0,
    "data-zds": true,
    onClick: props.onClick,
    role: props.role
  };
  if (props.href) {
    return React__default.default.createElement(
      "li",
      Object.assign({}, liRole, { "data-zds": true }),
      React__default.default.createElement(
        components_navigation_Link_Link.Link,
        Object.assign({}, commonProps, { component: props.component, color: null, href: props.disabled ? void 0 : props.href, rel: props.rel }),
        React__default.default.createElement("span", { className: styles.text, "data-zds": true }, props.children)
      )
    );
  }
  return React__default.default.createElement(
    "li",
    Object.assign({}, liRole, { "data-zds": true }),
    React__default.default.createElement(
      "button",
      Object.assign({}, commonProps, { disabled: props.disabled, type: "button" }),
      React__default.default.createElement("span", { className: styles.text, "data-zds": true }, props.children)
    )
  );
};

exports.MenuItem = MenuItem;
//# sourceMappingURL=MenuItem.cjs.js.map
